var _defs, _path, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e14a39;\n      }\n\n      .cls-2 {\n        fill: #26a95d;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.17,3.11c-.09-.47-.38-.88-.83-1.15-.61-.36-1.41-.42-2.24-.15-1.62.52-2.6,2.15-3.1,3.25-.5-1.09-1.49-2.73-3.1-3.25-.84-.27-1.63-.22-2.24.15-.44.27-.74.67-.83,1.15-.23,1.25.61,2.3,2.2,2.72.91.24,3.78.76,3.9.78.02,0,.05,0,.07,0h0s0,0,0,0c.02,0,.05,0,.07,0,.12-.02,2.99-.54,3.9-.78,1.59-.42,2.43-1.47,2.2-2.72ZM8.52,5.09c-.39-.1-1.66-.53-1.45-1.61.04-.22.18-.41.4-.53.2-.12.45-.18.73-.18.22,0,.46.04.7.12,1.31.42,2.11,1.93,2.47,2.78-.85-.16-2.29-.43-2.84-.58ZM15.48,5.09c-.55.15-1.99.42-2.84.58.36-.85,1.16-2.37,2.47-2.78.24-.08.48-.12.7-.12.28,0,.53.06.73.18.22.13.36.32.4.53.2,1.08-1.06,1.5-1.45,1.61Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.36,11.82H2.48v10.11c0,.23.19.41.41.41h8.47v-10.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.36,6.62H2.06c-.23,0-.41.19-.41.41v3.73h9.71v-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.94,6.62h-9.29v4.14h9.71v-3.73c0-.23-.19-.41-.41-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.64,22.35h8.47c.23,0,.41-.19.41-.41v-10.11h-8.88v10.53Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.15,
    y: 6.1,
    width: 1.69,
    height: 16.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift_icon.85f109fe0d8afc09545b21f6ffcefc78.svg";
export { ForwardRef as ReactComponent };